function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 44.7461,
  cy: 50,
  r: 4,
  fill: "#9d9974"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1s",
  values: "95;35",
  keyTimes: "0;1",
  begin: "-0.67s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0;1;1",
  keyTimes: "0;0.2;1",
  begin: "-0.67s"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 65.1461,
  cy: 50,
  r: 4,
  fill: "#9d9974"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1s",
  values: "95;35",
  keyTimes: "0;1",
  begin: "-0.33s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0;1;1",
  keyTimes: "0;0.2;1",
  begin: "-0.33s"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 84.9461,
  cy: 50,
  r: 4,
  fill: "#9d9974"
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "cx",
  repeatCount: "indefinite",
  dur: "1s",
  values: "95;35",
  keyTimes: "0;1",
  begin: "0s"
}), /*#__PURE__*/React.createElement("animate", {
  attributeName: "fill-opacity",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0;1;1",
  keyTimes: "0;0.2;1",
  begin: "0s"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-15 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 50L20 50A30 30 0 0 0 80 50Z",
  fill: "#d5cfb6",
  transform: "rotate(90 50 50)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50 50L20 50A30 30 0 0 0 80 50Z",
  fill: "#d5cfb6",
  transform: "rotate(15.0809 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0 50 50;45 50 50;0 50 50",
  keyTimes: "0;0.5;1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M50 50L20 50A30 30 0 0 1 80 50Z",
  fill: "#d5cfb6",
  transform: "rotate(-15.0809 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  dur: "1s",
  values: "0 50 50;-45 50 50;0 50 50",
  keyTimes: "0;0.5;1"
})));

var SvgLoadingGif = function SvgLoadingGif(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLoadingGif, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LoadingGif.2b3187b0.svg";
export { ForwardRef as ReactComponent };